import { IModel } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';

import { IDispatchFilter } from '../contracts/dispatch/dispatch-filter';

@Injectable({ providedIn: 'root' })
export class DispatchFilterService {
  private _dispatchFilters: IDispatchFilter[] = [];

  public register(dispatchFilter: IDispatchFilter) {
    this._dispatchFilters.push(dispatchFilter);
  }

  public async filter(payload: IModel[], modelName: string): Promise<IModel[]> {
    const filteredPayload = [...payload];
    const dispatchFilter = this._dispatchFilters.find(filter => filter.modelName === modelName);

    return dispatchFilter ? await dispatchFilter.filter(filteredPayload) : filteredPayload;
  }
}
